import { Injectable } from '@angular/core';

@Injectable()
export class TransportsService {

    public getTransports(request: any) {
        console.log ('pay', request);
        const arr = new Date(request['arrivalDate']);
        const dep = new Date(request['departureDate']);
        const pi = request['others']['transfers']['pickupHour'].split(':');
        const dro = request['others']['transfers']['returnHour'].split(':');
        const arrivalDate = new Date(arr.getFullYear(), arr.getMonth(), arr.getDate(), Number.parseInt(pi[0]), Number.parseInt(pi[1]));
        const deparDate = new Date(dep.getFullYear(), dep.getMonth(), dep.getDate(), Number.parseInt(dro[0]), Number.parseInt(dro[1]));
        const destination = request['destination'];
        const origin = request['origin'];
        const transport = {
            status: true,
            message: 'Results were found',
            totalRegs: 2,
            searchId: '20180218_4_2-4_1_9_f1bbf728eaf44cc78d75451a9adb7c4e_',
            results: this.getResults(arrivalDate, deparDate, destination, origin)
        };
        return transport;
    }

    public getResults(arrivalDate: Date, departureDate: Date, destination: string, origin: string): Array<any>{
        const results = [
            {
                providerId: 'c38d4060-f019-11e7-8204-9136922233a2',
                providerName: 'Nombre Proveedor',
                id: '103dd0',
                title: 'Picking you up Transports Service',
                description: 'The more commfortable transports services on the area.',
                categoryId: 1,
                productId: '1039136922233a2',
                origin: origin,
                destination: destination,
                dateIni: arrivalDate,
                dateEnd: departureDate,
                serviceResponse: null,
                nameAdapter: 'Hotel_Pro',
                additionalInfo: {
                    location: 'USA - ' ,
                    specialNotes: [
                            {
                            note: 'Resort Package Fee Mandatorio: $28.00 más impuestos, por habitación.....'
                            }
                        ],
                    transfers: {
                              pickupLocationId: 12359,
                              dropoffLocationId: 32546,
                      totalPrice: 251.23,
                          vehicles: [
                            {
                                tripType: 'first_leg',
                                        transferType: 'Regular / Premium',
                        productId: '1',
                        productTypeId: 8,
                        vehicleName: 'Peugeot 5008 o similar',
                        vehicleType: 'Minivan',
                        childAgeLimit: '9',
                        maxPax: 3,
                        maxBag: 4,
                        price: 22,
                        cancellationDate: '2018-03-21T13:00:00+00:00',
                        isHandicapped: false,
                        isTaxi: false,
                        transferTimeInMinutes: 30,
                        units: 2,
                        images: [
                                    {
                                       description: 'image description',
                                              image: 'http://casanovarentacar.mx/wp-content/uploads/2017/08/Captura-de-pantalla-2017-08-03-a-las-2.09.24-p.m..png',
                                              thumbnail: 'http://www.dominio.com/imagen/transfers/car1866_4th.jpg'
                                     }],
                             },
                                {
                                tripType: 'first_leg',
                                        transferType: 'Regular / Premium',
                        productId: '1',
                        productTypeId: 8,
                        name: 'Peugeot 5008 o similar',
                        vehicleType: 'Minivan',
                        childAgeLimit: '9',
                        maxPax: 3,
                        maxBag: 4,
                        price: 22,
                        cancellationDate: '2018-03-21T13:00:00+00:00',
                        isHandicapped: false,
                        isTaxi: false,
                        transferTimeInMinutes: 30,
                        units: 2,
                        images: [
                                    {
                                        description: 'image description',
                                             image: 'http://casanovarentacar.mx/wp-content/uploads/2017/08/Captura-de-pantalla-2017-08-03-a-las-2.09.48-p.m..png',
                                               thumbnail: 'http://www.dominio.com/imagen/transfers/car1866_4th.jpg'
                                     }],
                        }]
                    }
                 }
            },
            {
                providerId: 'c38d4060-f019-11e7-8204-9136922233a2',
                providerName: 'Nombre Proveedor',
                id: '103dd0',
                title: 'La Comarca\'s Transport Service',
                description: 'Third class transports, with the best prices of the whole country.',
                categoryId: 1,
                productId: null,
                origin: origin,
                destination: destination,
                dateIni: arrivalDate,
                dateEnd: departureDate,
                serviceResponse: null,
                nameAdapter: 'Hotel_Pro',
                additionalInfo: {
                    location: 'USA - ' ,
                    specialNotes: [
                            {
                            note: 'Resort Package Fee Mandatorio: $28.00 más impuestos, por habitación.....'
                            }
                        ],
                    transfers: {
                              pickupLocationId: 12359,
                              dropoffLocationId: 32546,
                      totalPrice: 154.79,
                          vehicles: [
                            {
                                tripType: 'first_leg',
                                        transferType: 'Regular / Premium',
                        productId: '1',
                        productTypeId: 8,
                        vehicleName: 'Peugeot 5008 o similar',
                        vehicleType: 'Minivan',
                        childAgeLimit: '9',
                        maxPax: 3,
                        maxBag: 4,
                        price: 22,
                        cancellationDate: '2018-03-21T13:00:00+00:00',
                        isHandicapped: false,
                        isTaxi: false,
                        transferTimeInMinutes: 30,
                        units: 2,
                        images: [
                                    {
                                       description: 'image description',
                                              image: 'http://www.wmxtur.com.br/imagens/fiat-ducato.png',
                                              thumbnail: 'http://www.dominio.com/imagen/transfers/car1866_4th.jpg'
                                     }],
                             },
                                {
                                tripType: 'first_leg',
                                        transferType: 'Regular / Premium',
                        productId: '1',
                        productTypeId: 8,
                        name: 'Peugeot 5008 o similar',
                        vehicleType: 'Minivan',
                        childAgeLimit: '9',
                        maxPax: 3,
                        maxBag: 4,
                        price: 22,
                        cancellationDate: '2018-03-21T13:00:00+00:00',
                        isHandicapped: false,
                        isTaxi: false,
                        transferTimeInMinutes: 30,
                        units: 2,
                        images: [
                                    {
                                        description: 'image description',
                                             image: 'http://www.wmxtur.com.br/imagens/fiat-ducato.png',
                                               thumbnail: 'http://www.dominio.com/imagen/transfers/car1866_4th.jpg'
                                     }],
                        }]
                    }
                 }
            },
            {
                providerId: 'c38d4060-f019-11e7-8204-9136922233a2',
                providerName: 'Nombre Proveedor',
                id: '103dd0',
                title: 'Jarvi\'s Deluxe Service',
                description: 'Executive transports, with the best customers service and the finest units.',
                categoryId: 1,
                productId: null,
                origin: origin,
                destination: destination,
                dateIni: arrivalDate,
                dateEnd: departureDate,
                serviceResponse: null,
                nameAdapter: 'Hotel_Pro',
                additionalInfo: {
                    location: 'USA - ' ,
                    specialNotes: [
                            {
                            note: 'Resort Package Fee Mandatorio: $28.00 más impuestos, por habitación.....'
                            }
                        ],
                    transfers: {
                              pickupLocationId: 12359,
                              dropoffLocationId: 32546,
                      totalPrice: 654.54,
                          vehicles: [
                            {
                                tripType: 'first_leg',
                                        transferType: 'Regular / Premium',
                        productId: '1',
                        productTypeId: 8,
                        vehicleName: 'Peugeot 5008 o similar',
                        vehicleType: 'Minivan',
                        childAgeLimit: '9',
                        maxPax: 3,
                        maxBag: 4,
                        price: 22,
                        cancellationDate: '2018-03-21T13:00:00+00:00',
                        isHandicapped: false,
                        isTaxi: false,
                        transferTimeInMinutes: 30,
                        units: 2,
                        images: [
                                    {
                                       description: 'image description',
                                              image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS3H18I6Cff6TiBt8b9jc5Gb7TKokZDddYSSNNCMKrbqw-wDW4kYQ',
                                              thumbnail: 'http://www.dominio.com/imagen/transfers/car1866_4th.jpg'
                                     }],
                             },
                                {
                                tripType: 'first_leg',
                                        transferType: 'Regular / Premium',
                        productId: '1',
                        productTypeId: 8,
                        name: 'Peugeot 5008 o similar',
                        vehicleType: 'Minivan',
                        childAgeLimit: '9',
                        maxPax: 3,
                        maxBag: 4,
                        price: 22,
                        cancellationDate: '2018-03-21T13:00:00+00:00',
                        isHandicapped: false,
                        isTaxi: false,
                        transferTimeInMinutes: 30,
                        units: 2,
                        images: [
                                    {
                                        description: 'image description',
                                             image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS3H18I6Cff6TiBt8b9jc5Gb7TKokZDddYSSNNCMKrbqw-wDW4kYQ',
                                               thumbnail: 'http://www.dominio.com/imagen/transfers/car1866_4th.jpg'
                                     }],
                        }]
                    }
                 }
            },
            {
                providerId: 'c38d4060-f019-11e7-8204-9136922233a2',
                providerName: 'Nombre Proveedor',
                id: '103dd0',
                title: '21 Pilot\'s Transports Services ',
                description: 'The more comfortable executives vans  in the whiole country, will make you believe you are lovely.',
                categoryId: 1,
                productId: null,
                origin: origin,
                destination: destination,
                dateIni: arrivalDate,
                dateEnd: departureDate,
                serviceResponse: null,
                nameAdapter: 'Hotel_Pro',
                additionalInfo: {
                    location: 'USA - ' ,
                    specialNotes: [
                            {
                            note: 'Resort Package Fee Mandatorio: $28.00 más impuestos, por habitación.....'
                            }
                        ],
                    transfers: {
                              pickupLocationId: 12359,
                              dropoffLocationId: 32546,
                      totalPrice: 350.70,
                          vehicles: [
                            {
                                tripType: 'first_leg',
                                        transferType: 'Regular / Premium',
                        productId: '1',
                        productTypeId: 8,
                        vehicleName: 'Peugeot 5008 o similar',
                        vehicleType: 'Minivan',
                        childAgeLimit: '9',
                        maxPax: 3,
                        maxBag: 4,
                        price: 22,
                        cancellationDate: '2018-03-21T13:00:00+00:00',
                        isHandicapped: false,
                        isTaxi: false,
                        transferTimeInMinutes: 30,
                        units: 2,
                        images: [
                                    {
                                       description: 'image description',
                                              image: 'http://www.wmxtur.com.br/imagens/fiat-ducato.png',
                                              thumbnail: 'http://www.dominio.com/imagen/transfers/car1866_4th.jpg'
                                     }],
                             },
                                {
                                tripType: 'first_leg',
                                        transferType: 'Regular / Premium',
                        productId: '1',
                        productTypeId: 8,
                        name: 'Peugeot 5008 o similar',
                        vehicleType: 'Minivan',
                        childAgeLimit: '9',
                        maxPax: 3,
                        maxBag: 4,
                        price: 22,
                        cancellationDate: '2018-03-21T13:00:00+00:00',
                        isHandicapped: false,
                        isTaxi: false,
                        transferTimeInMinutes: 30,
                        units: 2,
                        images: [
                                    {
                                        description: 'image description',
                                             image: 'data:image/jpeg;base64,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',
                                               thumbnail: 'http://www.dominio.com/imagen/transfers/car1866_4th.jpg'
                                     }],
                        }]
                    }
                 }
            },
            {
                providerId: 'c38d4060-f019-11e7-8204-9136922233a2',
                providerName: 'Nombre Proveedor',
                id: '103dd0',
                title: 'La Crem D\' la Crem\' Transports Services',
                description: 'The most comfortable and expensives limousines services of the whole country.',
                categoryId: 1,
                productId: null,
                origin: origin,
                destination: destination,
                dateIni: arrivalDate,
                dateEnd: departureDate,
                serviceResponse: null,
                nameAdapter: 'Hotel_Pro',
                additionalInfo: {
                    location: 'USA - ' ,
                    specialNotes: [
                            {
                            note: 'Resort Package Fee Mandatorio: $28.00 más impuestos, por habitación.....'
                            }
                        ],
                    transfers: {
                              pickupLocationId: 12359,
                              dropoffLocationId: 32546,
                      totalPrice: 1537.17,
                          vehicles: [
                            {
                                tripType: 'first_leg',
                                        transferType: 'Regular / Premium',
                        productId: '1',
                        productTypeId: 8,
                        vehicleName: 'Peugeot 5008 o similar',
                        vehicleType: 'Minivan',
                        childAgeLimit: '9',
                        maxPax: 3,
                        maxBag: 4,
                        price: 22,
                        cancellationDate: '2018-03-21T13:00:00+00:00',
                        isHandicapped: false,
                        isTaxi: false,
                        transferTimeInMinutes: 30,
                        units: 2,
                        images: [
                                    {
                                       description: 'image description',
                                              image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTmIQdHrGkm-dUXBJrFvQNc5UXNRlc-bobsFWeF1nltydc8Crc2OQ',
                                              thumbnail: 'http://www.dominio.com/imagen/transfers/car1866_4th.jpg'
                                     }],
                             },
                                {
                                tripType: 'first_leg',
                                        transferType: 'Regular / Premium',
                        productId: '1',
                        productTypeId: 8,
                        name: 'Peugeot 5008 o similar',
                        vehicleType: 'Minivan',
                        childAgeLimit: '9',
                        maxPax: 3,
                        maxBag: 4,
                        price: 22,
                        cancellationDate: '2018-03-21T13:00:00+00:00',
                        isHandicapped: false,
                        isTaxi: false,
                        transferTimeInMinutes: 30,
                        units: 2,
                        images: [
                                    {
                                        description: 'image description',
                                             image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTU6MOSjbt5mys-EzESQtSEpOZVSYbYk-G2JNzc7IOaSxm3bXiS',
                                               thumbnail: 'http://www.dominio.com/imagen/transfers/car1866_4th.jpg'
                                     }],
                        }]
                    }
                 }
            },
            {
                providerId: 'c38d4060-f019-11e7-8204-9136922233a2',
                providerName: 'Nombre Proveedor',
                id: '103dd0',
                title: 'Fancy David\'s Executive Transports Services ',
                description: 'Second class executive transport service.',
                categoryId: 1,
                productId: null,
                origin: origin,
                destination: destination,
                dateIni: arrivalDate,
                dateEnd: departureDate,
                serviceResponse: null,
                nameAdapter: 'Hotel_Pro',
                additionalInfo: {
                    location: 'USA - ' ,
                    specialNotes: [
                            {
                            note: 'Resort Package Fee Mandatorio: $28.00 más impuestos, por habitación.....'
                            }
                        ],
                    transfers: {
                              pickupLocationId: 12359,
                              dropoffLocationId: 32546,
                      totalPrice: 420.14,
                          vehicles: [
                            {
                                tripType: 'first_leg',
                                        transferType: 'Regular / Premium',
                        productId: '1',
                        productTypeId: 8,
                        vehicleName: 'Peugeot 5008 o similar',
                        vehicleType: 'Minivan',
                        childAgeLimit: '9',
                        maxPax: 3,
                        maxBag: 4,
                        price: 22,
                        cancellationDate: '2018-03-21T13:00:00+00:00',
                        isHandicapped: false,
                        isTaxi: false,
                        transferTimeInMinutes: 30,
                        units: 2,
                        images: [
                                    {
                                       description: 'image description',
                                              image: 'http://images.asiatravel.com/Hotel/5752/5752_queens_garden_resort_at_the_great_residence_van.jpg',
                                              thumbnail: 'http://www.dominio.com/imagen/transfers/car1866_4th.jpg'
                                     }],
                             },
                                {
                                tripType: 'first_leg',
                                        transferType: 'Regular / Premium',
                        productId: '1',
                        productTypeId: 8,
                        name: 'Peugeot 5008 o similar',
                        vehicleType: 'Minivan',
                        childAgeLimit: '9',
                        maxPax: 3,
                        maxBag: 4,
                        price: 22,
                        cancellationDate: '2018-03-21T13:00:00+00:00',
                        isHandicapped: false,
                        isTaxi: false,
                        transferTimeInMinutes: 30,
                        units: 2,
                        images: [
                                    {
                                        description: 'image description',
                                             image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS3H18I6Cff6TiBt8b9jc5Gb7TKokZDddYSSNNCMKrbqw-wDW4kYQ',
                                               thumbnail: 'http://www.dominio.com/imagen/transfers/car1866_4th.jpg'
                                     }],
                        }]
                    }
                 }
            }];
            console.log('Results', results)
        return results;
    }
}
